import {
	emailSendCustomerReportBadData,
	EmailSendCustomerReportBadDataProps
} from '@/modules/email/emailActions';
import type { RootState } from '@/rootReducer';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

export const useReportDataMutation = () => {
	const dispatch = useDispatch();

	const mutate = (props: EmailSendCustomerReportBadDataProps) => {
		dispatch(emailSendCustomerReportBadData(props));
	};

	const [isLoading, isSuccess, isError] = useSelector<
		RootState,
		[boolean, boolean, boolean]
	>(
		state => [
			state.email.getIn(['reportBadData', 'loading']),
			state.email.getIn(['reportBadData', 'failure']),
			state.email.getIn(['reportBadData', 'success'])
		],
		shallowEqual
	);

	return { mutate, isLoading, isSuccess, isError };
};
